import { Button, ButtonGroup, InputAdornment } from "@mui/material"
import { useState } from "react"

import { IDevice } from "../../../devices.interface"
import { SearchProps } from "./FilterSearch.interface"
import { StyledDiv, StyledSearchTextfield } from "./FilterSearch.styled"
import { useTranslation } from "react-i18next"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faSearch } from "@fortawesome/pro-solid-svg-icons"

const FilterSearch = ({
  showItemByFilter,
  search,
  devices,
  searchValue
}: SearchProps) => {
  const { t } = useTranslation()
  const [selectedFilter, setSelectedFilter] = useState(0)

  const filterSelect = (filter: number) => {
    setSelectedFilter(filter)
    showItemByFilter(filter)
  }

  return (
    <StyledDiv>
      <ButtonGroup>
        <Button
          className={selectedFilter === 0 ? "primary" : "inherit"}
          onClick={() => filterSelect(0)}
          variant="contained">
          {`${t("global.all", "All")} (${devices.length})`}
        </Button>
        <Button
          className={selectedFilter === 1 ? "primary" : "inherit"}
          onClick={() => filterSelect(1)}
          variant="contained">
          {`Online (${devices.filter((device: IDevice) => device.status === 1 || device.status === 2).length
            })`}
        </Button>
        <Button
          className={selectedFilter === 3 ? "primary" : "inherit"}
          onClick={() => filterSelect(3)}
          variant="contained">
          {`Offline (${devices.filter((device: IDevice) => device.status === 3).length})`}
        </Button>
      </ButtonGroup>
      <StyledSearchTextfield
        value={searchValue}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <FontAwesomeIcon icon={faSearch} />
            </InputAdornment>
          )
        }}
        onChange={(e) => search(e.target.value)}
        placeholder={t("global.search", "Search")}
        size="small"
      />
    </StyledDiv>
  )
}

export default FilterSearch
